var AbstractLogger = require("./AbstractLogger");
var postal = require("common/PubSub");

function DefaultLogger(logLevel) {
    AbstractLogger.call(this);

    var logArray = [];
    var capacity = 1000;

    this.getLog = function() {
        return logArray.slice(0).join("\n");
    };

    this.log = function(level, timestamp, msg) {
        if (logArray.length > capacity) {
            logArray.splice(0, 100);
        }
        logArray.push(timestamp + " [" + level + "] " + msg);
    };

    // Initialize with the currently configured log level
    postal.channel("Configuration").publish("loglevel", logLevel);
}

DefaultLogger.prototype = AbstractLogger;
DefaultLogger.prototype.constructor = DefaultLogger;

module.exports = DefaultLogger;